import { library } from '@fortawesome/fontawesome-svg-core'

import lightIcons from './light'
import solidIcons from './solid'
import brandsIcons from './brands'
import duotoneIcons from './duotone'
import regularIcons from './regular'

library.add(
  ...solidIcons,
  ...regularIcons,
  ...lightIcons,
  ...duotoneIcons,
  ...brandsIcons
)
